import Card from '../Card';

// Definindo o tipo localmente para evitar importação circular
export type JurosCompostosResult = {
  montante_final: number;
  total_investido: number;
  juros_totais: number;
  projecao: {
    ano: number;
    capital_acumulado: number;
    aportes_acumulados: number;
    juros_acumulados: number;
  }[];
}

type ResultadoJurosCompostosProps = {
  resultado: JurosCompostosResult;
}

export const ResultadoJurosCompostos = ({ resultado }: ResultadoJurosCompostosProps) => {
  // Função para formatar valores monetários
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  // Calcular percentual de juros sobre o investimento
  const percentualJuros = ((resultado.juros_totais / resultado.total_investido) * 100).toFixed(2);

  const stats = [
    { name: 'Montante Final', value: formatCurrency(resultado.montante_final) },
    { name: 'Total Investido', value: formatCurrency(resultado.total_investido) },
    { name: 'Juros Totais', value: formatCurrency(resultado.juros_totais) },
    { name: 'Rendimento', value: `${percentualJuros}%` },
  ];

  return (
    <Card>
      <h2 className="text-lg font-semibold text-gray-900">Resultado da Simulação</h2>
      <p className="text-sm text-gray-600">
        Com base nos parâmetros informados, veja o resultado da sua simulação de juros compostos.
      </p>
      
      <div className="grid grid-cols-2 gap-4 mt-4 h-full">
        {stats.map((stat) => (
          <div key={stat.name} className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm font-medium text-gray-500">{stat.name}</p>
            <p className="mt-1 text-lg font-semibold text-gray-900">{stat.value}</p>
          </div>
        ))}
      </div>
    </Card>
  );
};